import { useMutation } from "react-query";
import { getStripeSession } from "@/api/purchase.ts";
import { AxiosError } from "axios";

export const useStripeCheckout = () => {
  return useMutation<{ url: string }, AxiosError, { priceID: string }>(
    ({ priceID }) => {
      return getStripeSession(priceID);
    },
  );
};
